import { request } from './client.js';
// frequent-customer-memberships · Slice S4 (design §7, Capability 7) —
// valet-facing plate coverage lookup. Advisory only: the PWA uses this to
// render a "MEMBER — do not charge" banner while the valet is checking a
// vehicle in. The server-authoritative decision is enforced independently
// inside CreateTicketUseCase — this response must NEVER be trusted as a
// substitute for that enforcement.
/**
 * lookupMembershipByPlate — GET /valet/membership/lookup?plate=
 *
 * X-Location-Id is auto-injected by the client (harmless/unused server-side —
 * coverage is org-scoped, not location-scoped — but consistent with every
 * other /valet/* endpoint per client.ts's SKIP_LOCATION_HEADER_PATTERNS).
 */
export async function lookupMembershipByPlate(plate) {
    return request(`/valet/membership/lookup?plate=${encodeURIComponent(plate)}`, { method: 'GET' });
}
//# sourceMappingURL=valet-memberships.js.map